import { render, staticRenderFns } from "./PlayerResourceLogCopyLink.vue?vue&type=template&id=d14bc96e&"
import script from "./PlayerResourceLogCopyLink.vue?vue&type=script&lang=js&"
export * from "./PlayerResourceLogCopyLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports